import React from "react";
import Classes from "classnames";

import FormFieldFormElementProto from "../../form-element-proto";
import Input from 'core/gd-form/form-element/input/input';

class StringField extends FormFieldFormElementProto {

    constructor(props) {
        super(props);
    }

    onChange(newValue) {

        if (!newValue) newValue = '';

        const { onChange } = this.props;
        this.setState({value: newValue}, ()=>{
            if (onChange) onChange(newValue)
        });
    }

    render() {

        let classes;
        classes = Classes('gd-form-field-string','form-element',{});

        return (

            <div className={classes}>
                <Input size="big" form={this.props.form} name={this.props.name} />
            </div>

        );
    }

}

// StringField.propTypes = props;
// StringField.defaultProps = defaultProps;

export default function renderStringFormFieldFormElement(field, props) {
    return <StringField field={field} {...props} />;
}